"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingObserver = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const crypto = require("crypto");
const fs = require("fs");
const path = require("path");
class LoggingObserver {
    constructor(logFilePath) {
        this.logFilePath = logFilePath;
        this.log = [];
    }
    post(event) {
        this.writeLine(`${new Date().toLocaleString()} ${new Date().getMilliseconds()} ${event.eventName}`);
        const properties = event.getProperties();
        if (properties) {
            for (const property of Object.values(properties)) {
                this.writeLine(property);
            }
        }
        this.writeLine('');
    }
    innerDispose() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const directory = path.dirname(this.logFilePath);
            const tempFileName = `${path.basename(this.logFilePath)}.${crypto.randomUUID()}.tmp`;
            const tempFilePath = path.join(directory, tempFileName);
            yield fs.promises.mkdir(directory, { recursive: true });
            yield fs.promises.writeFile(tempFilePath, this.log.join('\n'), { flag: 'w' });
            const tempStats = yield fs.promises.stat(tempFilePath).catch(() => null);
            const existingStats = yield fs.promises.stat(this.logFilePath).catch(() => null);
            const tempSize = (_a = tempStats === null || tempStats === void 0 ? void 0 : tempStats.size) !== null && _a !== void 0 ? _a : 0;
            const existingSize = (_b = existingStats === null || existingStats === void 0 ? void 0 : existingStats.size) !== null && _b !== void 0 ? _b : 0;
            try {
                const shouldReplaceExisting = existingStats === null || tempSize > existingSize;
                if (shouldReplaceExisting) {
                    if (existingStats) {
                        fs.rmSync(this.logFilePath, { force: true });
                    }
                    fs.renameSync(tempFilePath, this.logFilePath);
                }
            }
            finally {
                if (fs.existsSync(tempFilePath)) {
                    fs.rmSync(tempFilePath, { force: true });
                }
            }
        });
    }
    dispose() {
        this.innerDispose().catch(() => { });
    }
    disposeAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.innerDispose().catch(() => { });
        });
    }
    getFileLocation() {
        return this.logFilePath;
    }
    writeLine(line) {
        this.log.push(line);
    }
}
exports.LoggingObserver = LoggingObserver;
//# sourceMappingURL=LoggingObserver.js.map